import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BorrowerTradelinesSmartComponent } from './borrower-tradelines-smart/borrower-tradelines-smart.component';
import { BorrowerTradelinesComponent } from './borrower-tradelines/borrower-tradelines.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    BorrowerTradelinesComponent,
    BorrowerTradelinesSmartComponent
  ],
  imports: [
    MatExpansionModule,
    MatProgressSpinnerModule,
    CommonModule,
  ],
  exports: [
    BorrowerTradelinesSmartComponent,
    BorrowerTradelinesComponent,
  ]
})
export class BorrowerTradelinesModule { }
